import { motion } from "framer-motion";
import { ArrowRight, Clock } from "lucide-react";
import { WaitlistForm } from "./WaitlistForm";

const REVEAL = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
};
const reveal = (delay = 0) => ({ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] });
const scrollToShop = () => document.getElementById("shop")?.scrollIntoView({ behavior: "smooth" });

export const HairCareNext = () => (
  <section id="hair-care-next" className="bg-[#F8F4EC] scroll-mt-28" data-testid="hair-care-next-section">
    <div className="max-w-7xl mx-auto px-6 sm:px-10 py-20 sm:py-28 grid lg:grid-cols-12 gap-12 items-center">
      <motion.div {...REVEAL} transition={reveal(0)} className="lg:col-span-5">
        <p className="font-mono-accent text-xs uppercase tracking-[0.3em] text-[#C9A45C] mb-4">Hair Care</p>
        <h2 className="font-serif-display font-medium text-4xl sm:text-5xl tracking-tight text-[#2B1F1B] leading-tight" data-testid="hair-care-next-heading">
          Next in <span className="italic text-[#3A2A25]">Hair Care.</span>
        </h2>
        <p className="mt-4 text-sm sm:text-base font-light text-[#756A64] leading-relaxed max-w-md">
          Simple care for softer, smoother, more manageable hair — and the line keeps growing.
        </p>
        <button
          type="button"
          onClick={scrollToShop}
          className="mt-8 inline-flex items-center gap-2 px-8 py-4 rounded-full bg-[#3A2A25] text-white text-xs font-semibold uppercase tracking-[0.2em] hover:bg-[#55423A] hover:-translate-y-0.5 hover:shadow-[0_12px_30px_rgba(58,42,37,0.25)] transition-[background-color,transform,box-shadow] duration-300"
          data-testid="hair-care-shop-button"
        >
          Shop Hair
          <ArrowRight size={14} strokeWidth={2} />
        </button>
      </motion.div>

      <motion.div
        {...REVEAL}
        transition={reveal(0.15)}
        className="lg:col-span-7 flex flex-col sm:flex-row rounded-2xl overflow-hidden bg-[#FFFDF9] border border-[rgba(58,42,37,0.08)]"
        data-testid="collection-card-mask"
      >
        <div className="relative bg-[#EDE3D6] sm:w-2/5">
          <img
            src="/images/repair-mask-silhouette.webp"
            alt="CELUSTA Repair Hair Mask — coming soon"
            loading="lazy"
            className="w-full h-64 sm:h-full object-contain p-8 opacity-80 mix-blend-multiply"
            data-testid="collection-card-mask-image"
          />
          <span className="absolute top-4 right-4 inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full bg-[#3A2A25] text-[#EDE3D6] text-[10px] font-mono-accent uppercase tracking-[0.2em]" data-testid="collection-card-mask-badge">
            <Clock size={11} strokeWidth={2} />
            Coming Soon
          </span>
        </div>
        <div className="flex flex-col flex-1 p-6 sm:p-8">
          <p className="font-mono-accent text-[10px] uppercase tracking-[0.25em] text-[#C9A45C]">Next in the Collection</p>
          <h3 className="mt-2 font-serif-display font-medium text-2xl text-[#2B1F1B]" data-testid="collection-card-mask-name">
            Repair Hair Mask
          </h3>
          <p className="mt-3 text-sm font-light text-[#756A64] leading-relaxed">
            A deeply restorative weekly treatment, in the works. Crafted to complete your CELUSTA hair ritual.
          </p>
          <WaitlistForm
            product="repair-hair-mask"
            className="mt-6 pt-6 border-t border-[rgba(58,42,37,0.08)]"
          />
        </div>
      </motion.div>
    </div>
  </section>
);
